// ../../react-shim.js
import React from "react";

// src/components/LocationContent/app.tsx
import { I18nextProvider } from "react-i18next";
import { LocationContext as LocationContext2 } from "@smile2impress/attraction-utils";
import {
  CountryVersion as CountryVersion7,
  ISOLanguagesCode,
  Language,
  UTSLocale as UTSLocale2,
  UTSLocaleToCountryVersion,
  UTSLocaleToLanguage
} from "@smile2impress/attraction-constants";

// src/components/LocationContent/ui.tsx
import { useContext, useEffect as useEffect2, useMemo as useMemo3, useRef, useState as useState2 } from "react";
import { useTranslation as useTranslation2 } from "react-i18next";
import { Button, Flex as Flex3, Text as Text4, Box as Box2 } from "@smile2impress/components";
import { LocationContext } from "@smile2impress/attraction-utils";
import { CountryVersion as CountryVersion6 } from "@smile2impress/attraction-constants";

// src/content/common.ts
var defaultContent = (t, { city }) => {
  return {
    locationQuestion: t("commonLocationContent:locationQuestion", { city }),
    positiveAnswer: t("commonLocationContent:positiveAnswer"),
    negativeAnswer: t("commonLocationContent:negativeAnswer"),
    regionQuestion: t("commonLocationContent:regionQuestion"),
    citySelectPlaceholder: t("commonLocationContent:citySelectPlaceholder")
  };
};
var common_default = defaultContent;

// src/content/english.ts
var pageContent = (t, props) => common_default(t, { ...props });
var english_default = pageContent;

// src/content/index.ts
var content_default = (version) => {
  switch (version) {
    default:
      return english_default;
  }
};

// src/api/location/location.ts
import axios from "axios";
import { CountrySlugs, UTSLocale } from "@smile2impress/attraction-constants";

// src/api/helpers.ts
var handleApiError = (error) => {
  if (error.response) {
    console.warn(error.response.data);
    console.warn(error.response.status);
    console.warn(error.response.headers);
  } else if (error.request) {
    console.warn(error.request);
  } else {
    console.warn("Error", error.message);
  }
};

// src/api/location/location.ts
var getLocationApiCountrySlug = (locale) => locale === UTSLocale.DENMARK_DK ? CountrySlugs[UTSLocale.SWEDEN_SE] : CountrySlugs[locale];
var createApiTransport = (apiUrl = "https://api-v2.smile2impress.com") => axios.create({ baseURL: apiUrl });
var fetchCities = async (axiosInstance, locale, branch) => {
  const queryParams = new URLSearchParams();
  if (branch) {
    queryParams.append("branch", branch);
  }
  return await axiosInstance.get(
    `/attraction-service/locations/v2/country/${getLocationApiCountrySlug(
      locale
    )}/clinicsIds`,
    { params: queryParams }
  ).then((response) => {
    return response.data.data;
  }).catch((error) => {
    handleApiError(error);
    return null;
  });
};

// src/api/location/location.types.ts
var ClinicType = /* @__PURE__ */ ((ClinicType2) => {
  ClinicType2["Teens"] = "teens";
  ClinicType2["Adults"] = "adults";
  ClinicType2["Combined"] = "combined";
  return ClinicType2;
})(ClinicType || {});
var ClinicCompanyType = /* @__PURE__ */ ((ClinicCompanyType2) => {
  ClinicCompanyType2["RENTED_BOX"] = "Rented box";
  ClinicCompanyType2["FLAGSHIP_CLINIC"] = "Flagship clinic";
  ClinicCompanyType2["PARTNER_CLINIC"] = "Partner clinic";
  return ClinicCompanyType2;
})(ClinicCompanyType || {});
var BranchType = /* @__PURE__ */ ((BranchType3) => {
  BranchType3["DR_SMILE"] = "dr-smile";
  BranchType3["Smajla"] = "smajla";
  return BranchType3;
})(BranchType || {});

// src/components/LocationContent/types.ts
var ActiveStepType = /* @__PURE__ */ ((ActiveStepType2) => {
  ActiveStepType2[ActiveStepType2["FIRST"] = 1] = "FIRST";
  ActiveStepType2[ActiveStepType2["SECOND"] = 2] = "SECOND";
  ActiveStepType2[ActiveStepType2["THIRD"] = 3] = "THIRD";
  return ActiveStepType2;
})(ActiveStepType || {});

// src/components/LocationContent/helpers.ts
import { CountryVersion as CountryVersion2 } from "@smile2impress/attraction-constants";

// src/constants.ts
import { CountryVersion } from "@smile2impress/attraction-constants";
var CountrySlugs2 = {
  [CountryVersion.SPAIN]: "esp",
  [CountryVersion.CATALAN]: "esp",
  [CountryVersion.FRANCE]: "fra",
  [CountryVersion.ITALY]: "ita",
  [CountryVersion.PORTUGAL]: "prt",
  [CountryVersion.UKRAINE]: "ukr",
  [CountryVersion.UK]: "gbr",
  [CountryVersion.US]: "usa",
  [CountryVersion.NL]: "nld",
  [CountryVersion.GERMANY]: "deu",
  [CountryVersion.SWEDEN]: "swe",
  [CountryVersion.DENMARK]: "dan"
};
var BUTTONS_IDS = /* @__PURE__ */ ((BUTTONS_IDS2) => {
  BUTTONS_IDS2["ACCEPT"] = "geolocation-assumption-accept";
  BUTTONS_IDS2["REJECT"] = "geolocation-assumption-reject";
  return BUTTONS_IDS2;
})(BUTTONS_IDS || {});
var excludedLocales = ["CATALAN", "DENMARK"];

// src/components/LocationContent/helpers.ts
var getTranslatedRegions = (t, version) => {
  return Object.entries(CountryVersion2).filter(([key]) => !excludedLocales.includes(key)).map(([_, region]) => {
    return {
      id: region,
      name: t(`countryTranslatedName${region}`),
      isActive: region === version
    };
  }).sort((region) => region.isActive ? -1 : 0);
};

// src/components/RegionsSelectDialogContent/RegionSelectDialogContent.tsx
import { Text as Text2 } from "@smile2impress/components";

// src/components/Regions/Regions.tsx
import {
  Icon as Icon2,
  Box,
  Text,
  Flex,
  ChevronRightOutlineIcon
} from "@smile2impress/components";
import { useTranslation } from "react-i18next";

// src/components/Regions/components/FlagIcon/index.tsx
import {
  Icon,
  EsIcon,
  FrIcon,
  ItIcon,
  PtIcon,
  GbIcon,
  UaIcon,
  UsIcon,
  DeIcon,
  NlIcon,
  SeIcon,
  DkIcon
} from "@smile2impress/components";
import { CountryVersion as CountryVersion3 } from "@smile2impress/attraction-constants";
import { jsx } from "react/jsx-runtime";
var FlagIcon = ({ version }) => {
  const getIcon = (FlagIconComponent) => /* @__PURE__ */ jsx(Icon, { as: FlagIconComponent, w: "24px", h: "24px" });
  switch (version) {
    case CountryVersion3.SPAIN:
    case CountryVersion3.CATALAN:
      return getIcon(EsIcon);
    case CountryVersion3.FRANCE:
      return getIcon(FrIcon);
    case CountryVersion3.ITALY:
      return getIcon(ItIcon);
    case CountryVersion3.PORTUGAL:
      return getIcon(PtIcon);
    case CountryVersion3.UK:
    case "united-kingdom":
      return getIcon(GbIcon);
    case CountryVersion3.UKRAINE:
      return getIcon(UaIcon);
    case CountryVersion3.US:
    case "united-states":
      return getIcon(UsIcon);
    case CountryVersion3.NL:
      return getIcon(NlIcon);
    case CountryVersion3.GERMANY:
      return getIcon(DeIcon);
    case CountryVersion3.SWEDEN:
      return getIcon(SeIcon);
    case CountryVersion3.DENMARK:
      return getIcon(DkIcon);
    default:
      return null;
  }
};

// src/configs/disabled-countries.ts
var disabledCountries = [];

// src/components/Regions/lib/is-country-disabled.ts
var isCountryDisabled = (country) => disabledCountries.includes(country);

// src/components/Regions/Regions.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var Regions = ({ version, onSelectRegion }) => {
  const { t } = useTranslation("commonLocationContent");
  const regions = getTranslatedRegions(t, version);
  return /* @__PURE__ */ jsx2(Flex, { children: /* @__PURE__ */ jsx2(
    Box,
    {
      as: "ul",
      width: "100%",
      backgroundColor: "transparent",
      listStyleType: "none",
      borderRadius: 2,
      p: 0,
      children: regions.map((region) => {
        if (isCountryDisabled(region.id)) return;
        const { id, name, isActive } = region;
        const countryId = id.replace(" ", "-").toLowerCase();
        return /* @__PURE__ */ jsxs(
          Flex,
          {
            as: "li",
            onClick: () => onSelectRegion(region),
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            _notLast: { mb: "24px" },
            children: [
              /* @__PURE__ */ jsxs(Flex, { alignItems: "center", children: [
                /* @__PURE__ */ jsx2(Box, { width: "24px", height: "24px", mr: "16px", children: /* @__PURE__ */ jsx2(
                  FlagIcon,
                  {
                    version: countryId
                  }
                ) }),
                /* @__PURE__ */ jsx2(
                  Text,
                  {
                    as: "span",
                    textStyle: "title3",
                    color: isActive ? "text.accent" : "text.primary",
                    _dark: {
                      color: isActive ? "text.accent" : "text.primaryInverse"
                    },
                    children: name
                  }
                )
              ] }),
              /* @__PURE__ */ jsx2(
                Icon2,
                {
                  as: ChevronRightOutlineIcon,
                  color: "text.tertiary"
                }
              )
            ]
          },
          id
        );
      })
    }
  ) });
};

// src/components/RegionsSelectDialogContent/RegionSelectDialogContent.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var RegionsSelectDialogContent = ({
  regionQuestion,
  ...props
}) => {
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    /* @__PURE__ */ jsx3(
      Text2,
      {
        textStyle: "title2",
        color: "text.primary",
        _dark: {
          color: "text.primaryInverse"
        },
        mr: 1,
        mb: 3,
        children: regionQuestion
      }
    ),
    /* @__PURE__ */ jsx3(Regions, { ...props })
  ] });
};

// src/components/CitySelectDialogContent/CitySelectDialogContent.tsx
import { useMemo as useMemo2 } from "react";
import {
  ChevronLeftOutlineIcon,
  Flex as Flex2,
  Icon as Icon4,
  Text as Text3
} from "@smile2impress/components";

// src/hooks/useFetchCities.ts
import { useEffect, useState } from "react";
import {
  CountryVersionToUTSLocale
} from "@smile2impress/attraction-constants";
var normalizeLabels = (cities) => cities.map((city) => {
  if (city.label) {
    city.title = city.label;
  }
  return city;
});
var useFetchCities = (axiosInstance, version, branch) => {
  const [isLoading, setIsLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const locale = CountryVersionToUTSLocale[version];
  useEffect(() => {
    const fetchCitiesData = async () => {
      setIsLoading(true);
      const cities2 = await fetchCities(axiosInstance, locale, branch);
      if (Array.isArray(cities2)) {
        setCities(normalizeLabels(cities2));
      }
      setIsLoading(false);
    };
    fetchCitiesData();
  }, [version]);
  return {
    cities,
    isLoading
  };
};

// src/components/CitySelect/CitySelect.tsx
import { useMemo } from "react";
import {
  Icon as Icon3,
  MagnifyingGlassOutlineIcon,
  Select
} from "@smile2impress/components";
import { sortBy } from "@smile2impress/attraction-utils";

// src/components/CitySelect/constants.ts
import { CountryVersion as CountryVersion5 } from "@smile2impress/attraction-constants";
var NoOptionsMessage = {
  [CountryVersion5.SPAIN]: "Sin opciones",
  [CountryVersion5.FRANCE]: "Aucune option",
  [CountryVersion5.ITALY]: "Nessuna opzione",
  [CountryVersion5.PORTUGAL]: "Nessuna opzione",
  [CountryVersion5.UKRAINE]: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0430\u0440\u0456\u0430\u043D\u0442\u0456\u0432",
  [CountryVersion5.UK]: "No options",
  [CountryVersion5.US]: "No options",
  [CountryVersion5.NL]: "No options",
  [CountryVersion5.GERMANY]: "No options",
  [CountryVersion5.SWEDEN]: "No options",
  [CountryVersion5.DENMARK]: "No options"
};
var LoadingMessage = {
  [CountryVersion5.SPAIN]: "Cargando...",
  [CountryVersion5.FRANCE]: "Chargement...",
  [CountryVersion5.ITALY]: "Caricamento...",
  [CountryVersion5.PORTUGAL]: "Carregando...",
  [CountryVersion5.UKRAINE]: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
  [CountryVersion5.UK]: "Loading...",
  [CountryVersion5.US]: "Loading...",
  [CountryVersion5.NL]: "Loading...",
  [CountryVersion5.GERMANY]: "Loading...",
  [CountryVersion5.SWEDEN]: "Loading...",
  [CountryVersion5.DENMARK]: "Loading..."
};

// src/components/CitySelect/CitySelect.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var CitySelect = ({
  version,
  options,
  value,
  maxMenuHeight,
  valueTestId,
  rootTestId,
  ...props
}) => {
  const sortedOptions = useMemo(() => sortBy(options, "title"), [options]);
  return /* @__PURE__ */ jsx4(
    Select,
    {
      options: sortedOptions,
      value,
      iconLeft: /* @__PURE__ */ jsx4(Icon3, { as: MagnifyingGlassOutlineIcon }),
      noOptionsMessage: () => NoOptionsMessage[version],
      loadingMessage: () => LoadingMessage[version],
      groupAlphabetically: true,
      minMenuHeight: 300,
      maxMenuHeight,
      getOptionLabel: ({ title, label }) => label || title,
      getOptionValue: ({ id }) => String(id),
      ...valueTestId && { valueTestId },
      ...rootTestId && { rootTestId },
      ...props
    }
  );
};

// src/components/CitySelectDialogContent/CitySelectDialogContent.tsx
import { Fragment as Fragment2, jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var CitySelectDialogContent = ({
  version,
  onChange,
  withBackButton,
  onBackButtonClick,
  theme: _,
  currentRegion,
  cityId,
  axiosInstance,
  ...selectProps
}) => {
  const { cities, isLoading } = useFetchCities(axiosInstance, version);
  const selectValue = useMemo2(
    () => cities.find((o) => o.id === cityId),
    [cities, cityId]
  );
  return /* @__PURE__ */ jsxs3(Fragment2, { children: [
    /* @__PURE__ */ jsxs3(Flex2, { mb: 4, alignItems: "center", children: [
      withBackButton && /* @__PURE__ */ jsx5(
        Icon4,
        {
          mr: 1,
          w: "24px",
          h: "24px",
          as: ChevronLeftOutlineIcon,
          onClick: onBackButtonClick,
          cursor: "pointer"
        }
      ),
      /* @__PURE__ */ jsx5(
        Text3,
        {
          textStyle: "title2",
          color: "text.primary",
          _dark: {
            color: "text.primaryInverse"
          },
          children: currentRegion?.name
        }
      )
    ] }),
    /* @__PURE__ */ jsx5(
      CitySelect,
      {
        version,
        options: cities,
        onChange: (option) => option && onChange(option),
        menuMode: "static",
        isLoading,
        dropdownIndicator: false,
        menuIsOpen: true,
        scrollBehaviour: "inside",
        value: selectValue,
        ...selectProps
      }
    )
  ] });
};

// src/components/LocationContent/ui.tsx
import { Fragment as Fragment3, jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var getContentByVersion = (t, version, predefinedCity) => content_default(version)(t, {
  city: predefinedCity?.value,
  version
});
var getRegionByVersion = (t, version) => {
  return getTranslatedRegions(t, version).find(({ id }) => id === version);
};
var popupModeStyles = {
  [2 /* SECOND */]: {
    width: "352px"
  },
  [3 /* THIRD */]: {
    width: "352px"
  }
};
var LocationContent = ({
  theme = "light",
  predefinedCity,
  defaultStep,
  hideArrow,
  onSelectRegion,
  onSelectCity,
  onSetActiveStep,
  activeStep: passedActiveStep,
  mode,
  menuListMaxSize = 450,
  apiUrl,
  axiosInstance
}) => {
  const { t } = useTranslation2("commonLocationContent");
  const { version = CountryVersion6.SPAIN } = useContext(LocationContext);
  const predefinedStep = predefinedCity ? 1 /* FIRST */ : 2 /* SECOND */;
  const [localActiveStep, setLocalActiveStep] = useState2(
    defaultStep || predefinedStep
  );
  const citySelectWrapper = useRef(null);
  const [listMaxSize, setListMaxSize] = useState2(menuListMaxSize);
  const isControlled = !!passedActiveStep;
  const activeStep = passedActiveStep ?? localActiveStep;
  const setActiveStep = (step) => isControlled ? onSetActiveStep?.(step) : setLocalActiveStep(step);
  const [currentRegion, setCurrentRegion] = useState2(
    getRegionByVersion(t, version)
  );
  const contentByVersion = useMemo3(
    () => getContentByVersion(t, version, predefinedCity),
    [t, version, predefinedCity]
  );
  const {
    locationQuestion,
    positiveAnswer,
    negativeAnswer,
    regionQuestion,
    citySelectPlaceholder
  } = contentByVersion;
  const handleSelectRegion = (region) => {
    setCurrentRegion(region);
    onSelectRegion && onSelectRegion(region);
    setActiveStep(3 /* THIRD */);
  };
  useEffect2(() => {
    if (!isControlled && onSetActiveStep) {
      onSetActiveStep(activeStep);
    }
  }, [activeStep]);
  useEffect2(() => {
    if (mode === "fullscreen" && activeStep === 3 /* THIRD */) {
      const viewportOffset = citySelectWrapper?.current?.querySelector(".chakra-react-select__menu")?.getBoundingClientRect();
      if (viewportOffset) {
        const top = viewportOffset.top;
        setListMaxSize(window.innerHeight - top);
      }
    }
  }, [mode, activeStep]);
  const memoizedAxiosInstance = useMemo3(
    () => axiosInstance ?? createApiTransport(apiUrl),
    [axiosInstance, apiUrl]
  );
  return /* @__PURE__ */ jsxs4(
    Flex3,
    {
      width: "100%",
      flexDirection: "column",
      padding: mode === "popup" ? 2 : 3,
      ...mode === "popup" && popupModeStyles[activeStep],
      children: [
        activeStep === 1 /* FIRST */ && predefinedCity && /* @__PURE__ */ jsxs4(Flex3, { flexDirection: "column", alignItems: "center", children: [
          /* @__PURE__ */ jsx6(Text4, { textStyle: "action", textAlign: "center", mb: 2, children: locationQuestion }),
          /* @__PURE__ */ jsxs4(Flex3, { gap: 1.5, width: "100%", children: [
            /* @__PURE__ */ jsx6(
              Button,
              {
                size: "md",
                variant: "primary",
                minWidth: 12,
                flexGrow: 1,
                onClick: () => onSelectCity(predefinedCity),
                id: "geolocation-assumption-accept" /* ACCEPT */,
                children: /* @__PURE__ */ jsx6(Fragment3, { children: positiveAnswer })
              }
            ),
            /* @__PURE__ */ jsx6(
              Button,
              {
                size: "md",
                variant: "secondary",
                minWidth: 12,
                flexGrow: 1,
                onClick: () => setActiveStep(2 /* SECOND */),
                id: "geolocation-assumption-reject" /* REJECT */,
                children: /* @__PURE__ */ jsx6(Fragment3, { children: negativeAnswer })
              }
            )
          ] })
        ] }),
        activeStep === 2 /* SECOND */ && /* @__PURE__ */ jsx6(
          RegionsSelectDialogContent,
          {
            regionQuestion,
            version,
            onSelectRegion: handleSelectRegion
          }
        ),
        activeStep === 3 /* THIRD */ && /* @__PURE__ */ jsx6(Box2, { ref: citySelectWrapper, children: /* @__PURE__ */ jsx6(
          CitySelectDialogContent,
          {
            theme,
            placeholder: citySelectPlaceholder,
            currentRegion,
            version: currentRegion?.id || version,
            onChange: ({ id, title, label }) => onSelectCity({
              id: String(id),
              value: label || title
            }),
            withBackButton: !hideArrow,
            onBackButtonClick: () => setActiveStep(2 /* SECOND */),
            captureMenuScroll: mode !== "default",
            ...predefinedCity && {
              cityId: parseInt(predefinedCity.id, 10)
            },
            maxMenuHeight: listMaxSize,
            axiosInstance: memoizedAxiosInstance
          }
        ) })
      ]
    }
  );
};

// src/components/LocationContent/app.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var LocationContent2 = ({
  i18n,
  locale = UTSLocale2.SPAIN_ES,
  language,
  version,
  ...restProps
}) => {
  let lng = version === CountryVersion7.US && language === Language.ENGLISH ? ISOLanguagesCode.us : language, ver = version;
  if (!lng || !ver) {
    lng = UTSLocaleToLanguage[locale];
    ver = UTSLocaleToCountryVersion[locale];
  }
  return /* @__PURE__ */ jsx7(I18nextProvider, { ...i18n, children: /* @__PURE__ */ jsx7(LocationContext2.Provider, { value: { version: ver, language: lng }, children: /* @__PURE__ */ jsx7(
    LocationContent,
    {
      ...restProps,
      version,
      language
    }
  ) }) });
};

// src/components/ClinicList/ClinicList.tsx
import { Flex as Flex4 } from "@smile2impress/components";

// src/components/ClinicList/components/ClinicBlock/ClinicBlock.tsx
import { Box as Box5, Heading, Text as Text5 } from "@smile2impress/components";
import { CountryVersion as CountryVersion8 } from "@smile2impress/attraction-constants";
import {
  getAddressPartAfterSemicolon,
  getAddressPartBeforeSemicolon
} from "@smile2impress/attraction-utils";

// src/components/ClinicList/components/Radio/Radio.tsx
import { Box as Box3 } from "@smile2impress/components";
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var Radio = ({
  isHoverActive = false,
  checked,
  hidden = false,
  ...restProps
}) => /* @__PURE__ */ jsxs5(
  Box3,
  {
    display: "block",
    position: "absolute",
    top: "16px",
    right: "16px",
    height: "24px",
    width: "24px",
    minWidth: "24px",
    cursor: "pointer",
    userSelect: "none",
    ...hidden && { visibility: "hidden" },
    children: [
      /* @__PURE__ */ jsx8(
        Box3,
        {
          as: "input",
          type: "radio",
          checked,
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: "100%",
          height: "100%",
          margin: 0,
          opacity: 0,
          cursor: "pointer",
          ...isHoverActive && { _after: { display: "block" } },
          ...checked && { _after: { display: "block" } },
          ...restProps
        }
      ),
      /* @__PURE__ */ jsx8(
        Box3,
        {
          position: "absolute",
          top: 0,
          left: 0,
          width: "24px",
          height: "24px",
          backgroundColor: "base.secondary",
          borderRadius: "12px",
          ...checked && {
            backgroundColor: "base.accent",
            _after: {
              content: '""',
              position: "absolute",
              top: "8px",
              left: "8px",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "base.primary"
            }
          }
        }
      )
    ]
  }
);

// src/components/ClinicList/components/Radio/components/RadioWithLabel/RadioWithLabel.tsx
import { useState as useState3 } from "react";
import { Box as Box4 } from "@smile2impress/components";

// src/components/ClinicList/components/Radio/context.tsx
import { createContext, useContext as useContext2 } from "react";
import { noop } from "@smile2impress/attraction-utils";
var RadioContext = createContext({
  value: "",
  onChange: noop
});
var RadioGroupContextProvider = RadioContext.Provider;
var useRadioContext = () => useContext2(RadioContext);

// src/components/ClinicList/components/Radio/components/RadioWithLabel/RadioWithLabel.tsx
import { jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var RadioWithLabel = ({
  value,
  id,
  children
}) => {
  const [isHoverActive, setHoverActive] = useState3(false);
  const { value: currentValue, onChange } = useRadioContext();
  const checked = value === currentValue;
  const handleOnMouseEnter = () => {
    setHoverActive(true);
  };
  const handleOnMouseLeave = () => {
    setHoverActive(false);
  };
  return /* @__PURE__ */ jsxs6(
    Box4,
    {
      as: "label",
      htmlFor: id,
      display: "flex",
      alignItems: "center",
      marginBottom: "16px",
      padding: "24px",
      cursor: "pointer",
      borderRadius: "8px",
      backgroundColor: "base.primary",
      border: "2px solid rgba(66, 78, 88, 0.1)",
      onMouseEnter: handleOnMouseEnter,
      onMouseLeave: handleOnMouseLeave,
      ...checked && {
        borderColor: "base.accent"
      },
      _last: {
        mb: 0
      },
      children: [
        /* @__PURE__ */ jsx9(
          Radio,
          {
            id,
            value,
            checked,
            isHoverActive,
            onChange
          }
        ),
        children
      ]
    }
  );
};

// src/components/ClinicList/components/Radio/components/RadioGroup/RadioGroup.tsx
import { useState as useState4, useEffect as useEffect3 } from "react";
import { noop as noop2 } from "@smile2impress/attraction-utils";
import { jsx as jsx10 } from "react/jsx-runtime";
var RadioGroup = ({
  children,
  defaultValue,
  onChange = noop2
}) => {
  const [state, setState] = useState4("");
  const handleOnChange = (e) => {
    setState(e.target.value);
    onChange(e);
  };
  useEffect3(() => {
    if (defaultValue) {
      setState(defaultValue);
    }
  }, [defaultValue]);
  return /* @__PURE__ */ jsx10(
    RadioGroupContextProvider,
    {
      value: { value: state, onChange: handleOnChange },
      children: /* @__PURE__ */ jsx10("div", { role: "radiogroup", children })
    }
  );
};
RadioGroup.RadioWithLabel = RadioWithLabel;

// src/components/ClinicList/components/ClinicBlock/ClinicBlock.tsx
import { jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var ClinicBlock = ({
  version,
  option,
  isSelected,
  onChange,
  teenTitle,
  quickSelection = false
}) => {
  const { id, clinic, type } = option;
  const { title, address } = clinic;
  const handleChange = () => {
    onChange?.(option);
  };
  const showAddress = version !== CountryVersion8.SPAIN || version === CountryVersion8.SPAIN && clinic.isFlagship;
  const ADDRESS_SPLIT_LOCALES = [CountryVersion8.FRANCE];
  const DISCLAIMER_SPLIT_LOCALES = [CountryVersion8.PORTUGAL];
  const rawClinicAddress = getAddressPartBeforeSemicolon(address);
  const extraClinicAddress = getAddressPartAfterSemicolon(address);
  const addressToShow = ADDRESS_SPLIT_LOCALES.includes(version) ? extraClinicAddress : rawClinicAddress;
  const inputId = `clinic-block-${id}`;
  const showPTClinicsDisclaimer = DISCLAIMER_SPLIT_LOCALES.includes(version) && extraClinicAddress;
  return /* @__PURE__ */ jsxs7(
    Box5,
    {
      as: "label",
      htmlFor: inputId,
      position: "relative",
      width: "100%",
      cursor: "pointer",
      display: "block",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "base.transparent",
      borderRadius: "16px",
      paddingTop: 2,
      paddingRight: 6,
      paddingBottom: 2,
      paddingLeft: 2,
      transition: "0.3s ease-out",
      _last: {
        mb: 0
      },
      ...(isSelected || quickSelection) && {
        borderColor: "base.secondary",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.12)"
      },
      onClick: handleChange,
      children: [
        /* @__PURE__ */ jsx11(
          Radio,
          {
            name: "clinic",
            value: id,
            id: inputId,
            onChange: handleChange,
            checked: isSelected,
            hidden: quickSelection
          }
        ),
        /* @__PURE__ */ jsx11(Heading, { textStyle: "title3", as: "h3", children: type === "teens" /* Teens */ ? `${title} ${teenTitle}` : title }),
        showAddress && /* @__PURE__ */ jsx11(Text5, { mt: "1", textStyle: "caption", children: addressToShow }),
        showPTClinicsDisclaimer && /* @__PURE__ */ jsx11(
          Text5,
          {
            textStyle: "captionSmall",
            color: "text.secondary",
            mt: "4px",
            children: extraClinicAddress
          }
        )
      ]
    }
  );
};

// src/components/ClinicList/ClinicList.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var ClinicList = ({
  version,
  options,
  value,
  onChange,
  content,
  withQuickClinicSelection
}) => {
  return /* @__PURE__ */ jsx12(Flex4, { flexDirection: "column", gap: 2, children: options.map((option) => /* @__PURE__ */ jsx12(
    ClinicBlock,
    {
      version,
      option,
      isSelected: option.id === value?.id,
      onChange,
      teenTitle: content.teensClinic,
      quickSelection: withQuickClinicSelection
    },
    option.id
  )) });
};

// src/components/ClinicList/utils.ts
var isCombinedClinic = (clinic) => clinic.clinicType === "combined" /* Combined */;
var sortClinicsByPriority = (clinics) => {
  return [...clinics].sort((a, b) => {
    const aPriority = a.priority ?? null;
    const bPriority = b.priority ?? null;
    if (aPriority !== null && bPriority !== null) {
      const priorityDiff = aPriority - bPriority;
      if (priorityDiff !== 0) {
        return priorityDiff;
      }
    } else if (aPriority !== null && bPriority === null) {
      return -1;
    } else if (aPriority === null && bPriority !== null) {
      return 1;
    }
    if (a.isFlagship !== b.isFlagship) {
      return Number(b.isFlagship) - Number(a.isFlagship);
    }
    return a.id - b.id;
  });
};
var getClinicOptionId = (id, type = "adults" /* Adults */) => type === "teens" /* Teens */ ? `${id}-${type}` : id.toString();
var getClinicOptions = (clinics) => sortClinicsByPriority(clinics).flatMap(
  (clinic) => (isCombinedClinic(clinic) ? ["adults" /* Adults */, "teens" /* Teens */] : ["adults" /* Adults */]).map((type) => ({
    type,
    clinic,
    id: getClinicOptionId(clinic.id, type)
  }))
);

// src/components/ClinicList/hooks.ts
import { useMemo as useMemo4 } from "react";
var useClinicOptions = (allClinics = [], selectedCity, isOptionMode = true) => {
  return useMemo4(() => {
    if (!selectedCity) return [];
    const filtered = allClinics.filter(
      (clinic) => clinic.cityId === selectedCity.id || clinic?.district !== null && (clinic?.district?.title === selectedCity.title || clinic?.district?.title === selectedCity.label)
    );
    if (!isOptionMode) {
      return filtered;
    }
    return getClinicOptions(filtered);
  }, [allClinics, selectedCity]);
};

// src/hooks/useFetchCurrentLocation.ts
import { useEffect as useEffect4, useState as useState5 } from "react";

// src/api/currentLocation/currentLocation.ts
import { CountrySlugs as CountrySlugs3 } from "@smile2impress/attraction-constants";
async function getCurrentLocation(axiosInstance, options) {
  try {
    const { country, count = 1, radius = 1e3 } = options;
    const filteredOptions = Object.entries({
      country: country ? CountrySlugs3[country] : void 0,
      count,
      radius
    }).filter(([_key, value]) => value !== void 0).map(([key, value]) => `${key}=${value}`).join("&");
    const response = await axiosInstance.get(
      `/locations/clinics${filteredOptions ? `?${filteredOptions}` : ""}`
    );
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
}

// src/hooks/useFetchCurrentLocation.ts
var useFetchCurrentLocation = (axiosInstance, options) => {
  const { enabled } = options;
  const [currentLocation, setCurrentLocation] = useState5(null);
  useEffect4(() => {
    if (!enabled) return;
    const fetchLocation = async () => {
      try {
        const location = await getCurrentLocation(
          axiosInstance,
          options
        );
        setCurrentLocation(location?.[0] ?? null);
      } catch (_) {
      }
    };
    fetchLocation();
  }, [enabled]);
  return { currentLocation };
};

// src/utils/filterCities.ts
var filterCities = (cities, filtersClinicCompanyType, filtersBranchType, filtersOnlyFlagships = false) => cities.map((city) => ({
  ...city,
  clinics: city.clinics.filter((clinic) => {
    const isCompanyTypeMatch = filtersClinicCompanyType.length > 0 ? filtersClinicCompanyType.includes(
      clinic.clinicCompanyType
    ) : true;
    const isBranchMatch = filtersBranchType === void 0 || clinic.branch === filtersBranchType;
    const isFlagshipMatch = filtersOnlyFlagships ? clinic.isFlagship : true;
    return isCompanyTypeMatch && isBranchMatch && isFlagshipMatch;
  })
})).filter((city) => city.clinics.length > 0);
var filterCitiesByClinicIds = (cities, clinicIds) => cities.map((city) => ({
  ...city,
  clinics: city.clinics.filter(
    (clinic) => clinicIds.includes(clinic.id)
  )
})).filter((city) => city.clinics.length > 0);
export {
  ActiveStepType,
  BUTTONS_IDS,
  BranchType,
  CitySelect,
  ClinicCompanyType,
  ClinicList,
  ClinicType,
  CountrySlugs2 as CountrySlugs,
  LocationContent2 as LocationContent,
  createApiTransport,
  excludedLocales,
  fetchCities,
  filterCities,
  filterCitiesByClinicIds,
  getClinicOptionId,
  getClinicOptions,
  useClinicOptions,
  useFetchCities,
  useFetchCurrentLocation
};
